import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOpbellen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M20.2 26a3.09 3.09 0 0 0 3.56.57l.38-.19a3.07 3.07 0 0 1 3.55.58l4.08 4.08a.73.73 0 0 1 .19.3.77.77 0 0 1-.49 1l-3.71 1.24a8.35 8.35 0 0 1-8.55-2L10 22.32a6.74 6.74 0 0 1-1.27-7.79l1.7-3.4a.8.8 0 0 1 .15-.2.76.76 0 0 1 1.08 0l4.21 4.2a3.09 3.09 0 0 1 .58 3.56l-.2.38a3.07 3.07 0 0 0 .58 3.55z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M16.1 4v6h-1V4zM23.024 7.284l-4.24 4.24-.708-.708 4.24-4.24zM25.6 14.5h-6v-1h6z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOpbellen);

export default ForwardRef;
